/* import __COLOCATED_TEMPLATE__ from './manually-add-questions.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { TrackedArray } from 'tracked-built-ins';

interface ManuallyAddQuestionsArgs {
  updateManuallyAddedQuestions: (questions: TrackedArray<QuestionInput>) => void;
  questionLimit: number;
  manuallyAddedQuestions: TrackedArray<QuestionInput>;
  questionNumberIsLessThanLimit: boolean;
}

class QuestionInput {
  @tracked text = '';

  constructor(text = '') {
    this.text = text;
  }
}

export default class ManuallyAddQuestions extends Component<ManuallyAddQuestionsArgs> {
  @action
  handlePaste(index: number, event: ClipboardEvent) {
    event.preventDefault();

    let pasteData = event.clipboardData?.getData('text');

    if (pasteData) {
      let newQuestions = pasteData
        .split(/\n/)
        .map((text) => text.trim())
        .filter((text) => text);

      if (newQuestions.length > 0) {
        this.args.updateManuallyAddedQuestions(
          new TrackedArray(
            [
              ...this.args.manuallyAddedQuestions.slice(0, index),
              ...newQuestions.map((text) => new QuestionInput(text)),
              ...this.args.manuallyAddedQuestions.slice(index + 1),
            ].slice(0, this.args.questionLimit),
          ),
        );
      }
    }
  }

  @action
  addQuestion() {
    this.args.manuallyAddedQuestions.push(new QuestionInput());
  }

  @action
  handleNewLine(index: number, event: KeyboardEvent) {
    event.preventDefault();
    this.args.updateManuallyAddedQuestions(
      new TrackedArray(
        [
          ...this.args.manuallyAddedQuestions.slice(0, index + 1),
          new QuestionInput(),
          ...this.args.manuallyAddedQuestions.slice(index + 1),
        ].slice(0, this.args.questionLimit),
      ),
    );
  }

  @action
  removeQuestion(index: number) {
    this.args.manuallyAddedQuestions.splice(index, 1);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::ManuallyAddQuestions': typeof ManuallyAddQuestions;
    'ai-agent/playground/manually-add-questions': typeof ManuallyAddQuestions;
  }
}
